import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Field } from "@/components/Field";

export const emptyPatient = () => ({ first_name: "", last_name: "", birth_date: "", sex: "", tax_code: "", phone: "",
  email: "", address: "", profession: "", height_cm: "", goal: "", first_visit_date: "", studio_id: "" });

export const cleanPatient = (f) => ({ ...f, email: f.email || null, studio_id: f.studio_id || null, height_cm: f.height_cm === "" || f.height_cm == null ? null : Number(f.height_cm) });

export function PatientFields({ form, setForm, disabled = false }) {
  const [studios, setStudios] = useState([]);
  useEffect(() => { api.get("/studios").then((r) => setStudios(r.data)); }, []);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const inp = (k, label, props = {}) => (
    <Field label={label}>
      <input className="field disabled:bg-slate-50" value={form[k] ?? ""} onChange={set(k)} disabled={disabled} data-testid={`patient-field-${k}`} {...props} />
    </Field>
  );
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      {inp("first_name", "Nome", { required: true })}
      {inp("last_name", "Cognome", { required: true })}
      {inp("birth_date", "Data di nascita", { type: "date" })}
      <Field label="Sesso">
        <select className="field disabled:bg-slate-50" value={form.sex || ""} onChange={set("sex")} disabled={disabled} data-testid="patient-field-sex">
          <option value="">—</option><option value="F">Femmina</option><option value="M">Maschio</option>
        </select>
      </Field>
      {inp("tax_code", "Codice fiscale")}
      {inp("phone", "Telefono", { type: "tel" })}
      {inp("email", "Email", { type: "email" })}
      {inp("profession", "Professione")}
      {inp("first_visit_date", "Data prima visita", { type: "date" })}
      <Field label="Studio di riferimento">
        <select className="field disabled:bg-slate-50" value={form.studio_id || ""} onChange={set("studio_id")} disabled={disabled} data-testid="patient-field-studio_id">
          <option value="">{studios.length ? "— Nessuno —" : "Nessuno studio inserito (pagina Studi)"}</option>
          {studios.map((s) => <option key={s.id} value={s.id}>{s.name}{s.city ? ` – ${s.city}` : ""}</option>)}
        </select>
      </Field>
      <div className="sm:col-span-2">{inp("address", "Indirizzo")}</div>
      <div className="sm:col-span-2">
        <Field label="Obiettivo / motivo della visita">
          <textarea className="field min-h-[70px] disabled:bg-slate-50" value={form.goal || ""} onChange={set("goal")} disabled={disabled} data-testid="patient-field-goal" />
        </Field>
      </div>
    </div>
  );
}
